export default function Links() {
  return (
    <div>
      anime
      <br />
      <a href="#">art</a>
      <br />
      <div id="01">
        <b>web art sites</b>
        <br />
        <a href="http://www.breedart.org" target="_blank" rel="noreferrer">
          breedart
        </a>
        <br />
        <a href="http://www.deviantart.com" target="_blank" rel="noreferrer">
          deviantart
        </a>
        <br />
        elfwood
        <br />
        <b>artists</b>
        <br />
        amy brown
        <br />
        H.R. Giger
        <br />
        <a href="http://www.luisroyo.com" target="_blank" rel="noreferrer">
          Luis Royo
        </a>
        <br />
        John Avon
        <br />
        Falcoon
        <br />
        Keiichi Kunishige
        <br />
        Ken Kelly
        <br />
        <b>movie related</b>
        <br />
        <a href="http://www.imdb.com" target="_blank" rel="noreferrer">
          imdb (internet movie database)
        </a>
        <br />
        <br />
      </div>
      games
      <br />
      <a href="#">music</a>
      <br />
      <div id="02">whateverish</div>
      friends
    </div>
  );
}
